/**
 * Maps human-readable keys to Framer XLIFF translation unit IDs.
 * Used by the homepage to look up translations from messages/{locale}.json.
 *
 * To find new keys: search messages/en.json under the "home" namespace
 * for the English text, then add the Framer ID here.
 */
export const homeKeys = {
  // Hero
  heroHeading: "heroHeading",
  heroSubtitle: "heroSubtitle",
  heroCtaPrimary: "heroCtaPrimary",
  heroCtaSecondary: "heroCtaSecondary",

  // Value proposition cards
  valueProp1: "valueProp1",
  valueProp2: "valueProp2",
  valueProp3: "valueProp3",
  valueProp4: "valueProp4",

  // Stats section: "Why early prevention matters"
  statsHeading: "statsHeading",
  statsDescription: "statsDescription",
  statValue1: "statValue1",
  statDesc1: "statDesc1",
  statHighlight1: "home_stat_highlight1",
  statValue2: "statValue2",
  statDesc2: "statDesc2",
  statHighlight2: "home_stat_highlight2",
  statValue3: "statValue3",
  statDesc3: "statDesc3",
  statHighlight3: "home_stat_highlight3",

  // Services carousel: "It's time to get the full picture"
  servicesHeading: "servicesHeading",
  servicesDescription: "servicesDescription",

  // How it works
  howItWorksHeading: "howItWorksHeading",
  howItWorksDescription: "howItWorksDescription",
  step1Title: "step1Title",
  step1Description: "step1Description",
  step2Title: "step2Title",
  step2Description: "step2Description",
  step3Title: "step3Title",
  step3Description: "step3Description",
  step4Title: "step4Title",
  step4Description: "step4Description",

  // Age groups: "Health changes, prevention should too"
  ageHeading: "ageHeading",
  ageDescription: "ageDescription",
  age30sRange: "home_age_30s_range",
  age30sTitle: "home_age_30s_title",
  age30sDescription: "home_age_30s_description",
  age30sLink: "home_age_30s_link",
  age40sRange: "home_age_40s_range",
  age40sTitle: "home_age_40s_title",
  age40sDescription: "home_age_40s_description",
  age40sLink: "home_age_40s_link",
  age60sRange: "home_age_60s_range",
  age60sTitle: "home_age_60s_title",
  age60sDescription: "home_age_60s_description",
  age60sLink: "home_age_60s_link",

  // Experts / doctors section
  expertsHeading: "expertsHeading",
  expertsSub: "expertsSub",
  doctorsCount: "doctorsCount",
  doctorsCountLabel: "doctorsCountLabel",
  doctorsLink: "doctorsLink",

  // Testimonials: "Real results from real people"
  testimonialsHeading: "testimonialsHeading",
  testimonialsDescription: "testimonialsDescription",
  videoTitle: "videoTitleMarco",
  videoSubtitle: "videoSubtitleMarco",
  videoTitle2: "videoTitleLucia",
  videoSubtitle2: "videoSubtitleLucia",
  // Pricing: "Find the right starting point"
  pricingHeading: "pricingHeading",
  pricingDescription: "pricingDescription",
  comparePackages: "comparePackages",
  pricingBloodEyebrow: "home_pricing_blood_eyebrow",
  pricingBloodTitle: "home_pricing_blood_title",
  pricingBloodDescription: "home_pricing_blood_description",
  pricingBloodForLabel: "home_pricing_blood_for_label",
  pricingBloodItem1: "home_pricing_blood_item_1",
  pricingBloodItem2: "home_pricing_blood_item_2",
  pricingBloodItem3: "home_pricing_blood_item_3",
  pricingBloodFrom: "home_pricing_blood_from",
  pricingBloodPrice: "home_pricing_blood_price",
  pricingBloodLink: "home_pricing_blood_link",
  pricingMriEyebrow: "home_pricing_mri_eyebrow",
  pricingMriTitle: "home_pricing_mri_title",
  pricingMriDescription: "home_pricing_mri_description",
  pricingMriForLabel: "home_pricing_mri_for_label",
  pricingMriItem1: "home_pricing_mri_item_1",
  pricingMriItem2: "home_pricing_mri_item_2",
  pricingMriItem3: "home_pricing_mri_item_3",
  pricingMriFrom: "home_pricing_mri_from",
  pricingMriPrice: "home_pricing_mri_price",
  pricingMriLink: "home_pricing_mri_link",

  // Insurance
  insuranceHeading: "home_insurance_heading",
  insuranceDescription: "home_insurance_description",
  insuranceKptLabel: "home_insurance_kpt_label",
  insuranceKptDescription: "home_insurance_kpt_description",
  insuranceMoreLabel: "home_insurance_more_label",
  insuranceCheckCoverageCta: "home_insurance_check_coverage_cta",
  insuranceContactCta: "home_insurance_contact_cta",

  // FAQ
  faqHeading: "faqHeading",
  faqLink: "faqLink",
  faqQ1: "home_faq_q1",
  faqA1: "home_faq_a1",
  faqQ2: "home_faq_q2",
  faqA2: "home_faq_a2",
  faqQ3: "home_faq_q3",
  faqA3: "home_faq_a3",
  faqQ4: "home_faq_q4",
  faqA4: "home_faq_a4",
  faqQ5: "home_faq_q5",
  faqA5: "home_faq_a5",
  faqQ6: "home_faq_q6",
  faqA6: "home_faq_a6",
  faqQ7: "home_faq_q7",
  faqA7: "home_faq_a7",
  faqQ8: "home_faq_q8",
  faqA8: "home_faq_a8",
  faqQ9: "home_faq_q9",
  faqA9: "home_faq_a9",

  // Scattered data section
  scatteredHeading: "scatteredHeading",
  scatteredSubtitle: "scatteredSubtitle",
  pillMedicalRecord: "home_pill_medical_record",
  pillMriScan: "home_pill_mri_scan",
  pillPrescriptions: "home_pill_prescriptions",
  pillBloodWork: "home_pill_blood_work",
  pillActionPlan: "home_pill_action_plan",
  pillLifestyleGoals: "home_pill_lifestyle_goals",
  cardName: "home_card_name",
  cardBiomarkers: "home_card_biomarkers",
  cardActionPoints: "home_card_action_points",

  // How it works – panel mockup labels (steps 1–4 decorative overlays)
  panelHsCrpText: "home_panel_hsCrpText",
  panelTwoActions: "home_panel_twoActions",
  panelHba1cLabel: "home_panel_hba1cLabel",
  panelIntermediate: "home_panel_intermediate",
  panelDiabetesRange: "home_panel_diabetesRange",
  panelPreDiabetesRange: "home_panel_preDiabetesRange",
  panelNormalRange: "home_panel_normalRange",
  panelFastingGlucose: "home_panel_fastingGlucose",
  panelConfirmed: "home_panel_confirmed",
  panelAppointmentDate: "home_panel_appointmentDate",
  panelAppointmentTime: "home_panel_appointmentTime",
  panelLocationCity: "home_panel_locationCity",
  panelLocationAddress: "home_panel_locationAddress",
  panelMmolUnit: "home_panel_mmolUnit",

  // Experiment: homepage-hero-v1
  heroPricingPill: "home_hero_pricing_pill",
  heroCtaFindTest: "home_hero_cta_find_test",

  // Membership-first homepage copy — rendered in the membership markets
  // (CH + AT) only; NL/DE keep the testing-first keys above. Gated by
  // `feature:membership-first-positioning` (lib/country-gates.ts).
  mfHeroHeading: "home_mf_hero_heading",
  mfHeroSubtitle: "home_mf_hero_subtitle",
  mfHeroCtaPrimary: "home_mf_hero_cta_primary",
  // Above-fold USP chips (membership markets) — stat + subtext, each links out.
  mfChipBiomarkersStat: "home_mf_chip_biomarkers_stat",
  mfChipBiomarkersSub: "home_mf_chip_biomarkers_sub",
  mfChipInsuranceStat: "home_mf_chip_insurance_stat",
  mfChipInsuranceSub: "home_mf_chip_insurance_sub",
  mfChipMriStat: "home_mf_chip_mri_stat",
  mfChipMriSub: "home_mf_chip_mri_sub",
  // Value-prop cards (membership-first arm)
  mfValueProp1: "home_mf_value_prop_1",
  mfValueProp2: "home_mf_value_prop_2",
  mfValueProp3: "home_mf_value_prop_3",
  mfValueProp4: "home_mf_value_prop_4",
  // Services carousel header (membership-first arm)
  mfServicesHeading: "home_mf_services_heading",
  mfServicesDescription: "home_mf_services_description",
  // How-it-works = membership lifecycle (membership-first arm)
  mfHowItWorksHeading: "home_mf_how_it_works_heading",
  mfHowItWorksDescription: "home_mf_how_it_works_description",
  mfStep1Title: "home_mf_step1_title",
  mfStep1Description: "home_mf_step1_description",
  mfStep2Title: "home_mf_step2_title",
  mfStep2Description: "home_mf_step2_description",
  mfStep3Title: "home_mf_step3_title",
  mfStep3Description: "home_mf_step3_description",
  mfStep4Title: "home_mf_step4_title",
  mfStep4Description: "home_mf_step4_description",
  // Pricing-package selector header (membership-first arm)
  mfPricingHeading: "home_mf_pricing_heading",
  mfPricingDescription: "home_mf_pricing_description",
  // Bottom CTA (membership-first arm)
  mfCtaTitle: "home_mf_cta_title",
  mfCtaSubtitle: "home_mf_cta_subtitle",
  mfCtaPrimary: "home_mf_cta_primary",

  // Bottom CTA
  ctaTitle: "ctaTitle",
  ctaSubtitle: "ctaSubtitle",
  ctaPrimary: "ctaPrimary",
  ctaSecondary: "ctaSecondary",

  // Homepage membership section + hero pill
  homepageMembershipPill: "homepage_membership_pill",
  homepageMembershipHeading1: "homepage_membership_heading_1",
  homepageMembershipHeading2: "homepage_membership_heading_2",
  homepageMembershipHeading3: "homepage_membership_heading_3",
  homepageMembershipPrice: "homepage_membership_price",
  homepageMembershipCtaPrimary: "homepage_membership_cta_primary",
  homepageMembershipCtaSecondary: "homepage_membership_cta_secondary",
  homepageMembershipFeature1: "homepage_membership_feature_1",
  homepageMembershipFeature2: "homepage_membership_feature_2",
  homepageMembershipFeature3: "homepage_membership_feature_3",
  homepageMembershipFeature4: "homepage_membership_feature_4",
  homepageMembershipFeature5: "homepage_membership_feature_5",
  homepageMembershipFeature6: "homepage_membership_feature_6",
  // Google rating in hero
  homepageGoogleReviews: "homepageGoogleReviews",
  // Stat card sources
  statSourceLancet: "home_stat_source_lancet",
  statSourceClinicalData: "home_stat_source_clinical_data",
} as const
